import React, { useState } from 'react';
import { Upload, Palette, Eye, Save, Globe, Lock, ChevronDown, Monitor, Smartphone, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const CURRENCIES = [{
  code: 'USD',
  label: 'US Dollar',
  symbol: '$'
}, {
  code: 'CAD',
  label: 'Canadian Dollar',
  symbol: 'C$'
}];
const LOCATIONS = [{
  code: 'US',
  label: 'United States'
}, {
  code: 'CA',
  label: 'Canada'
}];
export function BrandHub() {
  const [primaryColor, setPrimaryColor] = useState('#4F46E5');
  const [secondaryColor, setSecondaryColor] = useState('#0F172A');
  const [brandName, setBrandName] = useState('MyReseller Pro');
  const [currency, setCurrency] = useState('USD');
  const [location, setLocation] = useState('US');
  const [slaText, setSlaText] = useState('This hosting plan guarantees 99.9% uptime and 24/7 priority support...');
  return <div className="space-y-6 max-w-[1600px] mx-auto h-full flex flex-col" data-id="element-768">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-769">
        <div data-id="element-770">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-771">Brand Hub</h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-772">
            White-Label Engine: Configure your brand identity and global
            storefront settings.
          </p>
        </div>
        <div className="flex gap-3" data-id="element-773">
          <button className="px-4 py-2.5 text-sm font-bold text-gray-600 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-774">
            Discard
          </button>
          <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-775">
            <Save size={18} data-id="element-776" />
            Publish Branding
          </button>
        </div>
      </div>

      <div className="flex-1 grid grid-cols-1 lg:grid-cols-2 gap-6 min-h-0" data-id="element-777">
        {/* Left Column: Control Panel */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm flex flex-col overflow-hidden" data-id="element-778">
          <div className="flex-1 overflow-y-auto p-8 space-y-8" data-id="element-779">
            <div className="space-y-6" data-id="element-780">
              <div className="space-y-2" data-id="element-781">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-782">
                  Brand Name
                </label>
                <input type="text" value={brandName} onChange={e => setBrandName(e.target.value)} className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500/20 outline-none transition-all font-medium" data-id="element-783" />
              </div>

              <div className="grid grid-cols-2 gap-6" data-id="element-784">
                <div className="space-y-2" data-id="element-785">
                  <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-786">
                    Light Mode Logo
                  </label>
                  <div className="border-2 border-dashed border-gray-200 rounded-lg p-6 flex flex-col items-center justify-center gap-2 hover:border-indigo-400 transition-colors cursor-pointer bg-gray-50 group" data-id="element-787">
                    <Upload size={20} className="text-gray-400" data-id="element-788" />
                    <span className="text-[10px] font-bold text-gray-400" data-id="element-789">
                      SVG/PNG
                    </span>
                  </div>
                </div>
                <div className="space-y-2" data-id="element-790">
                  <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-791">
                    Dark Mode Logo
                  </label>
                  <div className="border-2 border-dashed border-slate-800 rounded-lg p-6 flex flex-col items-center justify-center gap-2 hover:border-indigo-400 transition-colors cursor-pointer bg-slate-900 group" data-id="element-792">
                    <Upload size={20} className="text-slate-500" data-id="element-793" />
                    <span className="text-[10px] font-bold text-slate-500" data-id="element-794">
                      SVG/PNG
                    </span>
                  </div>
                </div>
              </div>

              <div className="space-y-2" data-id="element-795">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-796">
                  Favicon (32x32)
                </label>
                <div className="flex items-center gap-4 p-4 bg-gray-50 border border-gray-200 rounded-lg border-dashed hover:border-indigo-400 cursor-pointer transition-all" data-id="element-797">
                  <div className="w-8 h-8 bg-white rounded border border-gray-200 flex items-center justify-center" data-id="element-798">
                    <Globe size={16} className="text-gray-400" data-id="element-799" />
                  </div>
                  <span className="text-xs font-bold text-gray-400" data-id="element-800">
                    Upload .ico or .png
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-6" data-id="element-801">
                <div className="space-y-2" data-id="element-802">
                  <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-803">
                    Primary Color
                  </label>
                  <div className="flex gap-2" data-id="element-804">
                    <input type="color" value={primaryColor} onChange={e => setPrimaryColor(e.target.value)} className="w-10 h-10 rounded-lg cursor-pointer border-none p-0 overflow-hidden" data-id="element-805" />
                    <input type="text" value={primaryColor} onChange={e => setPrimaryColor(e.target.value)} className="flex-1 px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-xs font-mono font-bold" data-id="element-806" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-807">
                  <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-808">
                    Global Currency
                  </label>
                  <div className="relative" data-id="element-809">
                    <select value={currency} onChange={e => setCurrency(e.target.value)} className="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg appearance-none text-xs font-bold text-slate-900 focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-810">
                      {CURRENCIES.map(c => <option key={c.code} value={c.code} data-id="element-811">
                          {c.code} - {c.label}
                        </option>)}
                    </select>
                    <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={14} data-id="element-812" />
                  </div>
                </div>
              </div>

              <div className="space-y-2" data-id="element-813">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-814">
                  Target Region (US & Canada Only)
                </label>
                <div className="relative" data-id="element-815">
                  <select value={location} onChange={e => setLocation(e.target.value)} className="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg appearance-none text-xs font-bold text-slate-900 focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-816">
                    {LOCATIONS.map(l => <option key={l.code} value={l.code} data-id="element-817">
                        {l.label}
                      </option>)}
                  </select>
                  <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={14} data-id="element-818" />
                </div>
              </div>
            </div>

            <div className="pt-6 border-t border-gray-100" data-id="element-819">
              <div className="flex items-center justify-between mb-4" data-id="element-820">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-821">
                  SLA Manager
                </label>
                <div className="flex gap-2" data-id="element-822">
                  {['$35', '$65', '$99'].map(tier => <button key={tier} className="text-[10px] font-bold text-gray-500 bg-gray-100 px-2 py-0.5 rounded uppercase hover:bg-indigo-50 hover:text-indigo-600 transition-all" data-id="element-823">
                      {tier} Tier
                    </button>)}
                </div>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm" data-id="element-824">
                <div className="flex border-b border-gray-100 p-2 gap-1 bg-gray-50/50" data-id="element-825">
                  <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:bg-white hover:text-indigo-600 hover:shadow-sm rounded transition-all font-bold text-xs" data-id="element-826">
                    B
                  </button>
                  <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:bg-white hover:text-indigo-600 hover:shadow-sm rounded transition-all font-bold text-xs italic" data-id="element-827">
                    I
                  </button>
                  <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:bg-white hover:text-indigo-600 hover:shadow-sm rounded transition-all font-bold text-xs underline" data-id="element-828">
                    U
                  </button>
                </div>
                <div contentEditable onBlur={e => setSlaText(e.currentTarget.textContent || '')} className="w-full h-32 p-4 text-sm focus:outline-none resize-none font-medium text-slate-600 overflow-y-auto" suppressContentEditableWarning={true} data-id="element-829">
                  {slaText}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Live Preview Frame */}
        <div className="bg-slate-900 rounded-lg border border-slate-800 shadow-2xl overflow-hidden flex flex-col" data-id="element-830">
          <div className="bg-slate-800/50 px-6 py-4 border-b border-slate-700 flex items-center justify-between" data-id="element-831">
            <div className="flex items-center gap-3" data-id="element-832">
              <div className="flex gap-1.5" data-id="element-833">
                <div className="w-3 h-3 rounded-full bg-red-500/60" data-id="element-834"></div>
                <div className="w-3 h-3 rounded-full bg-amber-500/60" data-id="element-835"></div>
                <div className="w-3 h-3 rounded-full bg-emerald-500/60" data-id="element-836"></div>
              </div>
              <div className="h-4 w-[1px] bg-slate-700 mx-2" data-id="element-837"></div>
              <div className="flex items-center gap-2" data-id="element-838">
                <Eye size={14} className="text-slate-400" data-id="element-839" />
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-840">
                  Live Preview: Customer OS
                </span>
              </div>
            </div>
            <div className="flex gap-2" data-id="element-841">
              <button className="p-1.5 text-slate-400 hover:text-white transition-colors" data-id="element-842">
                <Monitor size={16} data-id="element-843" />
              </button>
              <button className="p-1.5 text-slate-500" data-id="element-844">
                <Smartphone size={16} data-id="element-845" />
              </button>
            </div>
          </div>

          <div className="flex-1 bg-gray-50 flex overflow-hidden" data-id="element-846">
            {/* Mock Sidebar */}
            <div className="w-16 bg-slate-900 flex flex-col items-center py-6 gap-6" data-id="element-847">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center text-white font-bold text-xl shadow-lg" style={{
              backgroundColor: primaryColor
            }} data-id="element-848">
                {brandName.charAt(0)}
              </div>
              <div className="space-y-4" data-id="element-849">
                {[1, 2, 3, 4].map(i => <div key={i} className={`w-8 h-8 rounded-lg ${i === 1 ? 'bg-white/10' : 'bg-transparent'} flex items-center justify-center`} data-id="element-850">
                    <div className={`w-4 h-4 rounded ${i === 1 ? 'bg-white' : 'bg-slate-700'}`} data-id="element-851"></div>
                  </div>)}
              </div>
            </div>

            {/* Mock Content */}
            <div className="flex-1 flex flex-col" data-id="element-852">
              <header className="h-14 bg-white border-b border-gray-200 flex items-center justify-between px-6" data-id="element-853">
                <div className="text-xs font-bold text-slate-900" data-id="element-854">
                  {brandName} Portal
                </div>
                <div className="flex gap-3" data-id="element-855">
                  <div className="w-8 h-8 rounded-full bg-gray-100" data-id="element-856"></div>
                </div>
              </header>
              <main className="p-6 space-y-6" data-id="element-857">
                <div className="grid grid-cols-2 gap-4" data-id="element-858">
                  <div className="h-24 bg-white rounded-lg border border-gray-200 p-4 space-y-3" data-id="element-859">
                    <div className="w-12 h-2 bg-gray-100 rounded" data-id="element-860"></div>
                    <div className="text-lg font-bold" style={{
                    color: primaryColor
                  }} data-id="element-861">
                      $2,450.00
                    </div>
                  </div>
                  <div className="h-24 bg-white rounded-lg border border-gray-200 p-4 space-y-3" data-id="element-862">
                    <div className="w-12 h-2 bg-gray-100 rounded" data-id="element-863"></div>
                    <div className="text-lg font-bold text-slate-900" data-id="element-864">
                      12 Active Sites
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-lg border border-gray-200 p-6 space-y-4" data-id="element-865">
                  <div className="flex items-center justify-between" data-id="element-866">
                    <div className="text-xs font-bold text-slate-900" data-id="element-867">
                      Service Level Agreement
                    </div>
                    <button className="px-4 py-2 rounded-lg text-white text-[10px] font-bold shadow-lg" style={{
                    backgroundColor: primaryColor
                  }} data-id="element-868">
                      Accept SLA
                    </button>
                  </div>
                  <p className="text-[10px] text-gray-500 leading-relaxed italic" data-id="element-869">
                    "{slaText}"
                  </p>
                </div>
              </main>
            </div>
          </div>

          <div className="p-4 bg-slate-800/30 border-t border-slate-700 flex items-center justify-center gap-6" data-id="element-870">
            <div className="flex items-center gap-2" data-id="element-871">
              <div className="w-2 h-2 rounded-full bg-emerald-500" data-id="element-872"></div>
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-873">
                System Online
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-874">
              <Check size={12} className="text-indigo-400" data-id="element-875" />
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-876">
                SSL Secure
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}